export const getVersion = () => 'v2.3.12'
